// https://vuex.vuejs.org/en/mutations.html

export default {
  auth_request (state) {
    state.authStatus = 'loading'
  },
  auth_success (state, { user }) {
    state.authStatus = 'success'
    state.user = user
  },
  auth_error (state) {
    state.authStatus = 'error'
  },
  logout (state) {
    state.authStatus = ''
    state.user = ''
  },
  setTableList (state, tableList) {
    state.tableList = tableList
  }
}
